import { render, staticRenderFns } from "./ContinuousFilingEscalationFile.vue?vue&type=template&id=56ed0a20&scoped=true&"
import script from "./ContinuousFilingEscalationFile.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousFilingEscalationFile.vue?vue&type=style&index=0&id=56ed0a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed0a20",
  null
  
)

export default component.exports